export const FETCH_EMAIL_LOG_SUCCESS = "FETCH_EMAIL_LOG_SUCCESS";
export const FETCH_EMAIL_LOG_BY_CLIENT_SUCCESS = "FETCH_EMAIL_LOG_BY_CLIENT_SUCCESS";
export const FETCH_EMAIL_LOG_BY_USER_SUCCESS = "FETCH_EMAIL_LOG_BY_USER_SUCCESS";
export const FETCH_VIEW_EMAIL_LOG_SUCCESS = 'FETCH_VIEW_EMAIL_LOG_SUCCESS';
export const DELETE_EMAIL_LOG_SUCCESS = 'DELETE_EMAIL_LOG_SUCCESS'
export const EMAIL_LOG_FILTER_CHANGE = 'EMAIL_LOG_FILTER_CHANGE';
export const UPDATE_EMAIL_TYPE_SUCCESS = 'UPDATE_EMAIL_TYPE_SUCCESS'